import parse from "html-react-parser";
import Button, { ButtonA } from "../../../../..//Elements/Button/Button.js";
import apiRequest from "../../../../../../utils/ApiRequest/apiRequest.js";
import config from "config";
import ToastHtmlComponent from "../../../../../Reusable/ToastHtmlComponent/ToastHtmlComponent.js";
import GlobalPopUp from "../../../../../Reusable/GlobalPopUp/GlobalPopUp.js";
import SimpleContent from "components/Structure/ModalManager/SimpleContent.js";
import { useModal } from "../../../../../../contexts/modalContext/modalContext.js";
import { useContent } from "../../../../../../contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";

const DeleteUserModal = ({ userData }) => {
  const { closeModal, setModal } = useModal();
  const { addToast } = useToasts();
  const { getTextByKey, getLanguage } = useContent();

  const deleteUser = async () => {
    const response = await apiRequest(
      "Users",
      `ReactSendMailToDeleteUserData?Culture=${getLanguage()}`,
      null,
      "POST"
    );
    if (response.status === "success") {
      if (response && response.data) {
        const popUpText = getTextByKey("sent-mail-delete-user-data").replace(
          "%UserEmailAddress%",
          userData.UserName
        );
        setModal(() => <GlobalPopUp text={parse(popUpText)} />);
      } else {
        let errText = getTextByKey("api-error");
        errText = errText.replace("#ERRORNUM#", response.data);
        errText = errText.replace("#SYSMAIL#", "contact-us");
        errText = errText.replace("#SYSMAIL#", config.supportmail);
        errText = errText.replace("#SYSMAIL#", "contact-us");
        addToast(<ToastHtmlComponent htmlStr={errText} />, {
          appearance: "error",
        });
        closeModal();
      }
    } else {
      if (response.data === "user-has-active-mails") {
        setModal({
          modal: SimpleContent,
          props: {
            title: "need-to-delete-active-mails-title",
            message: "need-to-delete-active-mails-message",
            actionButton: (
              <ButtonA
                title={getTextByKey("need-to-delete-active-mails-button")}
                page="inbox?t=sent&sm=active"
              />
            ),
          },
        });
      } else {
        let errText = getTextByKey("api-error");
        errText = errText.replace("#ERRORNUM#", 999);
        errText = errText.replace("#SYSMAIL#", "contact-us");
        errText = errText.replace("#SYSMAIL#", config.supportmail);
        errText = errText.replace("#SYSMAIL#", "contact-us");
        addToast(<ToastHtmlComponent htmlStr={errText} />, {
          appearance: "error",
        });
        closeModal();
      }
    }
    return response;
  };

  return (
    <div className="delete-account-modal">
      <div className="top-section">
        <div className="modal-content">
          <div className="modal-body">
            <div>
              <h1>{getTextByKey("profileuserdetails-delete-account-btn")}</h1>
              <p>
                {parse(getTextByKey("profileuserdetails-delete-account-note"))}
              </p>
            </div>
            <div className="actions">
              <Button
                buttonClass="recover-cancel-button"
                blank
                onClick={() => {
                  closeModal();
                }}
              >
                {getTextByKey("jumboforms-delete-form-cancel")}
              </Button>
              <Button
                blank
                buttonClass="recover-link-button"
                onClick={() => {
                  deleteUser();
                }}
              >
                {getTextByKey("profileuserdetails-delete-account-btn")}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-section"></div>
    </div>
  );
};

export default DeleteUserModal;
